import React from 'react';
import { observer } from 'owa-mobx-react';
import { getStore } from '../store/store';

const store = getStore();

export const DialogHost = observer(() => {
    return <div>{Array.from(store.dialogs.values())}</div>;
}, 'DialogHost');
